import { render } from "./DividendBackfill.vue?vue&type=template&id=451f1e53"
import script from "./DividendBackfill.vue?vue&type=script&lang=js"
export * from "./DividendBackfill.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__